export const pcgSettingsDevelopment = {"mode":"Development","apiBaseUrl":"https://localhost:5001","rollbarPostClientToken":"d5f69f08a4e5455198da93518f68c55c"};
